import React, { Component } from 'react';
import {getPagination} from 'components/pianoroll/PianoRollPagination.js';
import StepData from 'pattern/StepData.js';
import Track from 'track/Track.js';
import {onMouseUp} from './onMouseUp.js';
import Notes from 'midi/Notes.js';
import { connect } from "react-redux";
import Resolution from 'engine/Resolution.js';
import {mouseDown} from 'actions/index.js';
import {dragToggle} from 'actions/index.js';
import {dragStepTranspose} from 'actions/index.js';
import {setStepDragging} from 'actions/index.js';
import {setStepDataDragging} from 'actions/index.js';
import {setStepAndDataDragging} from 'actions/index.js';
import {setStepToCopy} from 'actions/index.js';
import {setIsDraggingDuration} from 'actions/index.js';
import {setPianoRollSelection} from 'actions/index.js';
import {
    setSelectedPianoRollSteps,
    setSelectedFreeze
} from 'actions/index.js';
import {setTransposeDragging} from 'actions/index.js';
import {setPianoRollDragOffset} from 'actions/index.js';
import {
    addStep,
    updateStepParameter,
    deleteSteps,
    moveSteps,
    snapToGrid
} from 'operations/actions.js';
import {WIDTH, LEFT_SPACE} from './constants.js';
import Colors from 'components/Colors.js';
const colors = new Colors();

const DURATION_RESOLUTION = new Resolution(16, false);
const baseResolution = Track.baseResolution;

class PianoRollGridStep extends Component {
    constructor(props) {
        super(props);
        this.state = {
            offset: undefined,
        };
        this.operationManager = this.props.sequencerEngine.operationManager;
    }

    get scrollLeft() {
        if (this.props.parentClassName) {
            let el = this.parentElement || document
                .getElementsByClassName(this.props.parentClassName)[0];
            if (this.parentElement === undefined) {
                this.parentElement = el;
            }
            return el.scrollLeft;
        }
        return 0;
    }

    // returns the width in pixels of the step (for duration = 1)
    get width() {
        return this.props.xScale * WIDTH * this.props.resolution.numSteps() / 16;
    }

    deleteStep() {
        this.operationManager.dispatch(deleteSteps(
            this.props.track,
            [this.props.stepData]));
        this.props.track.updateSteps();

        this.props.setSelectedPianoRollSteps(undefined);
    }


    onMouseDown(e, setStepNumber=true) {
        e.stopPropagation();
        e.preventDefault();

        // NEed to keep track of where within the step, you clicked in
        // so that when you drag the step, the mouse remains at the same
        // position, relative to the step.
        this.props.setPianoRollDragOffset(this.getClickOffset(e));

        // update redux state
        this.props.mouseDown(true);

        // keep track of what the transpose was
        this.props.setDragStepTranspose(this.note.getTranspose());

        if (setStepNumber) {
            let stepNumber = this.getStepNumber(e);
            this.props.setStepDragging(stepNumber);
        }
        // keep track of the step being operated on 
        this.props.setStepToCopy(this.props.stepData);
        this.props.setTransposeDragging(this.note.getTranspose());

        let step = this.props.stepData;
        if (this.props.selectedPianoRollSteps !== undefined &&
            !this.props.selectedPianoRollSteps.some(selected => selected.id === step.id)) {
            // user clicked a step outside of the selection, so
            // reset the selection
            this.props.setSelectedPianoRollSteps(undefined);
        }
    }

    getState() {
        return this.props.sequencerEngine.store.getState();
    }

    get note() {
        return this.getState().keyboard.notes[this.props.noteIndex] ||
            Notes.NOTES[0];
    }

    onMouseUp(e) {
        e.stopPropagation();
        e.preventDefault();
        let step = this.props.stepData;
        let state = this.props.sequencerEngine.store.getState();

        // first handle the "click" event, where we toggle a step on or off
        if (state.keyboard.isDraggingDuration) {
            // do nothing in this case
        } else if (state.keyboard.pianoRollSelection !== undefined &&
                   state.keyboard.pianoRollSelection.numNotes > 1 &&
                  state.keyboard.pianoRollSelection.numNotes > 1) {
            // select notes
            let selectedSteps = this.props.track.getEasyPattern()
                .getSelectedPianoRollSteps(state.keyboard.pianoRollSelection,
                                 this.props.resolution);

            this.props.setSelectedPianoRollSteps(selectedSteps);
            this.props.setSelectedFreeze(undefined);
            this.props.setPianoRollSelection(undefined);
        } else if (state.keyboard.pianoRollSelection === undefined) {
            if (!this.isSelectedStep()) {
                // when the step is not selected, we need to select
                // that step
                this.props.setSelectedPianoRollSteps([this.props.stepData]);
                this.props.setSelectedFreeze(undefined);
                this.props.setPianoRollSelection(undefined);
            } else if (
                state.keyboard.stepDataDragging === undefined ||
                step.id !== state.keyboard.stepDataDragging.id)
            {
                // when the step IS selected, and step is not dragging, we delete
                // it
                this.deleteStep();
                this.props.setSelectedPianoRollSteps(undefined);
                this.props.track.updateSteps();
            } else {
                this.snapToGridIfNecessary();
            }
        } 

        onMouseUp(this.props);
    }

    // user clicks the right edge of step, triggering
    // the start of "changing a step's duration"
    dragStepDuration(e) {
        this.props.setIsDraggingDuration(true);
        this.props.setStepAndDataDragging(
            parseFloat(this.props.stepNumber) + parseFloat(this.props.position),
            this.getState().keyboard.stepToCopy);

        this.onMouseDown(e, false);
    }

    isSelectedStep() {
        return this.props.selectedPianoRollSteps !== undefined 
            && this.props.selectedPianoRollSteps.indexOf(this.props.stepData) > -1;
    }

    moveSteps(e, steps=[this.props.stepData]) {
        let offset = this.getClickOffset(e);
        let stepsMoved = offset / (WIDTH * this.props.xScale);
        let positionOffset = this.props.position;
        stepsMoved += parseFloat(positionOffset);

        let dragOffset = this.getState().keyboard.dragOffset || 0;
        dragOffset = dragOffset / (WIDTH * this.props.xScale);
        dragOffset += parseFloat(positionOffset);

        let stepDiff = parseFloat(stepsMoved) - parseFloat(dragOffset);
        let transformation = {
            stepDifference: baseResolution.transformStepAtResolution2(stepDiff, this.props.resolution),
            transposeDifference: 0,
        };
        if (Math.abs(transformation.stepDifference) <= 0.001) {
            return;
        }
        
        this.operationManager.dispatch(moveSteps(
            this.props.track,
            steps,
            transformation,
            baseResolution,
            true,
            true));
    }

    getStepNumber(e) {
        return (this.scrollLeft + e.pageX - LEFT_SPACE) / (WIDTH * this.props.xScale);
    }

    // Returns the number of pixels from the start of the step that
    // the click occurs at
    // For example, if you click in the middle of a step of width=100,
    // then this will return 50!
    getClickOffset(e) {
        let remaining = 62;
        return this.scrollLeft + e.pageX - this.getLeft() - remaining;
    }

    onMouseMove(e) {
        e.stopPropagation();
        let state = this.getState();
        let isMouseDown = state.keyboard.isMouseDown;
        let selection = state.keyboard.pianoRollSelection;

        if (isMouseDown && !state.keyboard.isDraggingDuration && selection === undefined) {
            let stepNumber = this.getStepNumber(e);
            if (state.keyboard.stepDataDragging && state.keyboard.stepDataDragging !== this.props.stepData) {
                return;
            }
            this.props.setStepAndDataDragging(stepNumber, state.keyboard.stepToCopy);
            if (state.keyboard.selectedPianoRollSteps !== undefined &&
               state.keyboard.selectedPianoRollSteps.length > 1) {
                this.moveSteps(e, state.keyboard.selectedPianoRollSteps);
            } else {
                this.moveSteps(e);
            }
        } else if  (isMouseDown && this.getState().keyboard.isDraggingDuration) {
            let offset = this.getClickOffset(e);
            let stepsMoved = offset / this.width;
            this.updateDuration(stepsMoved + 0.1);
       }
    }

    updateDuration(newDuration) {
        newDuration = Math.max(0.1, newDuration);
        let stepDataToChange = this.getState().keyboard.stepToCopy
            .getStepDataForTranspose(this.note.getTranspose(), true);
        if (stepDataToChange === undefined) {
            return;
        }
        let originalDuration = stepDataToChange.duration;
        let durationMultiplier = newDuration / originalDuration;
  
        this.operationManager.dispatch(
            updateStepParameter(
                this.props.track,
                stepDataToChange,
                stepDataToChange.durationParameter,
                newDuration));
        // stepDataToChange.duration = newDuration;
        let state = this.getState();
        if (state.keyboard.selectedPianoRollSteps !== undefined) {
            // then update each duration by the multiplier
            if (durationMultiplier !== Infinity) {
                let trackDuration = this.props.track.trackData.duration;
                state.keyboard.selectedPianoRollSteps
                    .filter(step => step !== stepDataToChange)
                    .forEach(
                        step =>
                            this.operationManager.dispatch(
                                updateStepParameter(
                                    this.props.track,
                                    step,
                                    step.durationParameter,
                                    Math.max(
                                        0.1,
                                        step.duration !== null ?
                                            step.duration * durationMultiplier :
                                            trackDuration * durationMultiplier)
                                )));
            }
            this.props.track.updateSteps();
        }
        this.setState(this.state);
    }

    snapToGridIfNecessary() {
        if (!this.getState().sequencer.quantized ||
            this.props.resolution.isTriplet) {
            // when in unquantized mode we don't need to snap
            // to grid

            // TODO: figure out how to do snap to grid in triplet
            return;
        }
        let steps = this.getState().keyboard.selectedPianoRollSteps;
        this.operationManager.dispatch(snapToGrid(
            this.props.track,
            steps,
            this.props.resolution));
        this.props.track.updateSteps();
    }

    // returns the amt of pixels from the left, that the step is
    // positioned on (not including scroll). This
    // takes into account x-scala, step position and step number;
    getLeft() {
        let unquantizedOffset = this.props.position * WIDTH * this.props.xScale;
        return this.props.stepNumber * WIDTH * this.props.xScale + unquantizedOffset;
    }

    getStyle() {
        let style = {
            left: this.getLeft(),
            height: this.props.height,
        };

        if (this.props.stepData) {
            style.width = this.width * this.props.stepData.duration;
        } else {
            style.width = this.width * this.props.duration;
        }

        if (this.isSelectedStep()) {
            style.borderColor = this.props.color;
            style.backgroundColor = colors.brighten(this.props.color, 0.3);
        } else {
            style.backgroundColor = this.props.color;
        }
        return style;
    }

    render() {
        let className = this.props.isAlternateColor ? 'alternate ' : '';
        className += this.isSelectedStep() ? " selected " : "";
        if (this.props.isGuideStep) {
            className += " guide-step";
        }
        return (
            <div
              draggable={false}
              onMouseMove={(e) => this.onMouseMove(e)}
              onMouseDown={(e) => this.onMouseDown(e)}
              onMouseUp={(e) => this.onMouseUp(e)}
              style={this.getStyle()}
              className={className + ' grid-step toggled-grid-step on'}>
              {this.props.on ? 
                  <div
                    draggable={false}
                    onMouseDown={(e) => this.dragStepDuration(e)}
                    className="right-edge"></div> : ''}
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch, props) => {
    return {
        mouseDown: m => dispatch(mouseDown(m)),
        dragToggle: m => dispatch(dragToggle(m)),
        setStepDragging: step  => dispatch(setStepDragging(step)),
        setStepToCopy: step  => dispatch(setStepToCopy(step)),
        setTransposeDragging: transpose => dispatch(setTransposeDragging(transpose)),
        setDragStepTranspose: transpose => dispatch(dragStepTranspose(transpose)),
        setIsDraggingDuration: isDraggingDuration => dispatch(setIsDraggingDuration(isDraggingDuration)),
        setStepDataDragging: stepData => dispatch(setStepDataDragging(stepData)),
        setStepAndDataDragging: (stepNumber, stepData) => dispatch(setStepAndDataDragging(stepNumber, stepData)),
        setPianoRollSelection: (stepNumber, transpose, numSteps, numNotes) =>
            dispatch(setPianoRollSelection(stepNumber, transpose, numSteps, numNotes)),
        setSelectedPianoRollSteps: (steps) => dispatch(setSelectedPianoRollSteps(steps)),
        setPianoRollDragOffset: (offset) => dispatch(setPianoRollDragOffset(offset)),
        setSelectedFreeze: (freeze) => dispatch(setSelectedFreeze(freeze)),
    }
};

export default connect(null,  mapDispatchToProps)(PianoRollGridStep);
